import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid } from '@mui/material';
import ContractItemDetailComponent from './ContractItemDetailComponent';
import ContractListItemComponentSummary from './ContractListItemComponentSummary';
import { Button } from '@totalsoft/rocket-ui';
import { DetatchedAccordion } from 'components/common/CommonStyles';

const ContractListComponent = ({ t, leasingContractList, contractSelected, onSelectContract, onCloseContractSelectionModal }) => {
  const onSelectedItemChanged = selectionIndex => {
    const leasingContractSelected = leasingContractList[selectionIndex];
    onSelectContract({
      ...contractSelected,
      contractId: leasingContractSelected.contractId,
      contractSiteId: leasingContractSelected.contractSiteId,
      contractNumber: leasingContractSelected.contractNumber,
      originalContractId: leasingContractSelected.originalContractId,
      originalContractSiteId: leasingContractSelected.originalContractSiteId,
      leasingAdditionalDocumentId: leasingContractSelected.leasingAdditionalDocumentId,
      leasingAdditionalDocumentSiteId: leasingContractSelected.leasingAdditionalDocumentSiteId,
      terminationOptionId: leasingContractSelected.terminationOptionId,
      partnerId: leasingContractSelected.partnerId
    });
    onCloseContractSelectionModal();
  };

  return (
    <>
      {leasingContractList &&
        leasingContractList.length > 0 &&
        leasingContractList.map((contractLite, idx) => {
          return (
            <Grid item key={idx}>
              <DetatchedAccordion
                title={
                  <Grid container alignItems='center' px={2} gap={5}>
                    <ContractListItemComponentSummary contractLite={contractLite} />
                    <Grid item textAlign='end'>
                      <Button
                        id={'contractSelectionList_selectBtn_' + idx}
                        onClick={() => {
                          onSelectedItemChanged(idx);
                        }}
                        variant='text'
                        size='small'
                        disabled={
                          contractSelected &&
                          contractSelected.contractId === contractLite.contractId &&
                          contractSelected.contractSiteId === contractLite.contractSiteId
                        }
                      >
                        {contractSelected &&
                        contractSelected.contractId === contractLite.contractId &&
                        contractSelected.contractSiteId === contractLite.contractSiteId
                          ? t('Selected')
                          : t('Select')}
                      </Button>
                    </Grid>
                  </Grid>
                }
                content={
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.AssetName')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.Brand')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.Model')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.Version')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.PriceWithVAT')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.ChassisNumber')}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{t('RestructuringEdit.ContractList.Asset.Dealer')}</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {contractLite.contractDetails &&
                        contractLite.contractDetails.map((contractLiteDetail, idx) => {
                          return <ContractItemDetailComponent contractLiteDetail={contractLiteDetail} key={idx} />;
                        })}
                    </TableBody>
                  </Table>
                }
              />
            </Grid>
          );
        })}
    </>
  );
};

ContractListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  leasingContractList: PropTypes.array,
  contractSelected: PropTypes.object.isRequired,
  onSelectContract: PropTypes.func.isRequired,
  onCloseContractSelectionModal: PropTypes.func.isRequired
};

export default compose(withTranslation())(ContractListComponent);
